import * as React from 'react';

import Frame from '../Frame';
import type { EmbedProps as Props } from '.';

function Supademo(props: Props) {
  return <Frame {...props} src={props.attrs.href} title="Supademo Embed" />;
}

Supademo.isMatch = (href: string) => {
  const urlRegex = /^https:\/\/app\.supademo\.com\/embed\/(.*)$/;

  return urlRegex.test(href);
};

export default Supademo;
